export const fileIcon = {
  data() {
    return {
      unknown: require('@/assets/file/unknown.png'),
      cad: require('@/assets/file/cad.png'),
      dmg: require('@/assets/file/dmg.png'),
      doc: require('@/assets/file/doc.png'),
      docx: require('@/assets/file/docx.png'),
      dwf: require('@/assets/file/dwf.png'),
      dwg: require('@/assets/file/dwg.png'),
      jpeg: require('@/assets/file/jpeg.png'),
      jpg: require('@/assets/file/jpg.png'),
      mov: require('@/assets/file/mov.png'),
      pdf: require('@/assets/file/pdf.png'),
      png: require('@/assets/file/png.png'),
      ppt: require('@/assets/file/ppt.png'),
      psd: require('@/assets/file/psd.png'),
      rar: require('@/assets/file/rar.png'),
      tiff: require('@/assets/file/tiff.png'),
      txt: require('@/assets/file/txt.png'),
      xls: require('@/assets/file/xls.png'),
      xlsx: require('@/assets/file/xlsx.png'),
      zip: require('@/assets/file/zip.png')
    }
  },
  methods: {
    fileExtFormatter(fileExt) {
      try {
        // eslint-disable-next-line no-eval
        let icon = eval('this.' + fileExt)
        if (icon !== undefined) {
          return icon
        } else {
          return this.unknown
        }
      } catch (e) {
        return this.unknown
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/icon.js